export default {
	'01': {
		'name': 'Հունվար',
		'short': 'Jan',
		'number': 1,
		'days': 31,
	},
	'02': {
		'name': 'Փետրվար',
		'short': 'Feb',
		'number': 2,
		'days': 28,
	},
	'03': {
		'name': 'Մարտ',
		'short': 'Mar',
		'number': 3,
		'days': 31,
	},
	'04': {
		'name': 'Ապրիլ',
		'short': 'Apr',
		'number': 4,
		'days': 30,
	},
	'05': {
		'name': 'Մայիս',
		'short': 'May',
		'number': 5,
		'days': 31,
	},
	'06': {
		'name': 'Հունիս',
		'short': 'Jun',
		'number': 6,
		'days': 30,
	},
	'07': {
		'name': 'Հուլիս',
		'short': 'Jul',
		'number': 7,
		'days': 31,
	},
	'08': {
		'name': 'Օգոստոս',
		'short': 'Aug',
		'number': 8,
		'days': 31,
	},
	'09': {
		'name': 'Սեպտեմբեր',
		'short': 'Sep',
		'number': 9,
		'days': 30,
	},
	'10': {
		'name': 'Հոկտեմբեր',
		'short': 'Oct',
		'number': 10,
		'days': 31,
	},
	'11': {
		'name': 'Նոյեմբեր',
		'short': 'Nov',
		'number': 11,
		'days': 30,
	},
	'12': {
		'name': 'Դեկտեմբեր',
		'short': 'Dec',
		'number': 12,
		'days': 31,
	},
}
